/* react-linkify but I modified the decorators */
import React from 'react'
import { NetworkInterceptor } from 'network-interceptor'
import { logout } from 'phonecom'
import PropTypes from 'prop-types'

const FORBIDDEN_LOGOUT_DELAY_MS = 15000

const defaultContextValue = {
    forbidden: false,
    logoutUser: () => { /* no-op */ }
}

/**
 *
 */
export const LoginRedirectorContext = React.createContext(defaultContextValue)

/**
 *
 */
class LoginRedirector extends React.Component {
    /**
     * @param {object} props
     */
    constructor (props) {
        super(props)
        this.state = {
            forbidden: false
        }
        this.logoutTimer = null
    }

    clearForbidden = () => {
        this.setState({
            forbidden: false
        })
    }

    clearLogoutTimer = () => {
        if (this.logoutTimer) {
            clearTimeout(this.logoutTimer)
            this.logoutTimer = null
        }
    }

    startLogoutTimer = () => {
        if (this.logoutTimer) {
            return
        }

        this.logoutTimer = setTimeout(() => {
            this.logoutTimer = null
            this.logoutUser()
        }, FORBIDDEN_LOGOUT_DELAY_MS)
    }

    logoutUser = () => {
        this.clearLogoutTimer()
        this.clearForbidden()
        console.log('redirect')
        logout()
    }

    /**
     *
     */
    componentDidMount () {
        NetworkInterceptor((resp) => {
            const isForbidden =
            resp &&
            resp.responseURL &&
            resp.responseURL.includes('phone.com') &&
            (
                resp.status === 403 ||
                resp.response === '{"error": {"message": "Forbidden", "http_code": 403, "code": 403}}'
            )
            if (isForbidden) {
                this.setState({ forbidden: true }, this.startLogoutTimer)
                console.log(resp.responseURL)
                console.log('failed auth')
            }
        })
    }

    /**
     *
     */
    componentWillUnmount () {
        this.clearLogoutTimer()
    }

    /**
     *
     */
    render () {
        return (
            <LoginRedirectorContext.Provider
                value={{
                    forbidden: this.state.forbidden,
                    logoutUser: this.logoutUser
                }}
            >
                {this.props.children}
            </LoginRedirectorContext.Provider>
        )
    }
}

LoginRedirector.propTypes = {
    children: PropTypes.node
}

export default LoginRedirector
